<section>
  <header class="d-flex justify-content-between align-items-center main-heading">
    <div class="d-flex align-items-center">
      <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
        role="button" aria-controls="offcanvasExample">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
        </svg></a>
      <h3 class="heading-span" *ngIf="currentStep == 0">
        <span>School</span>
      </h3>
      <h3 class="heading-span" *ngIf="currentStep != 0">
        <span class="underline" (click)="resetCreateSchool()">School</span> / Create School
      </h3>
    </div>
  </header>
  
  <ul class="timeline-horizontal create-school-timeline d-flex" *ngIf="createIndividualSchoolForm">
    <li 
      [ngClass]="{'active': currentStep == steps.AddSchool , 'completed': currentStep == steps.CreateUser}"
      (click)="goToSelectedStep(steps.AddSchool)">
        <div class="step">STEP 1</div>
        <div class="heading">Add School</div>
      </li>
      <li 
        [ngClass]="{'active': currentStep == steps.CreateUser, 'completed': completedProcess}"
        (click)="goToSelectedStep(steps.CreateUser)">
        <div class="step">STEP 2</div>
        <div class="heading">Create Member / User</div>
      </li>
  </ul>

  <div class="mat-account-wrapper">
    <div *ngIf="createIndividualSchoolForm && currentStep == steps.AddSchool">
      <app-add-school [isEdit] = "isEdit" [schoolData]="createdSchoolDetails" [isIndividualEntity] = false [accountAdminList]="accountAdminList" ></app-add-school>
    </div>
    <div *ngIf="createIndividualSchoolForm && currentStep == steps.CreateUser">
      <app-create-user [isEdit] = "isEdit" [assignedPackageId]="packageToAssign" [clientAccountId]="clientAccountId" [schoolData]="[schoolToEdit]"></app-create-user>
    </div>
    <div class="sticky-btns w-100" *ngIf="createIndividualSchoolForm">
      <div class="row w-100">
          <div class="col-sm-6 text-start">
          <button *ngIf="currentStep != steps.AddSchool" type="button" class="btn theme-btn-outline px-5"
            (click)="handleBack()">
            Back
          </button>
          <button *ngIf="currentStep == steps.AddSchool && !isEdit" type="button" class="btn theme-btn-outline px-5" (click)="resetCreateSchool()">
            Cancel
          </button>
        </div>
        <div class="col-sm-6 text-end">
          <button type="button" class="btn theme-btn px-5 ms-3" (click)="triggerAction()">
            {{ currentStep == steps.CreateUser ? "Submit" : "Next" }}
          </button>
          <button *ngIf="currentStep == steps.AddSchool" type="button" class="btn theme-btn-outline px-5 ms-3" (click)="partialSave = true; triggerAction()">
            {{ "Submit" }}
          </button>
          </div>
      </div>
    </div>
  </div>
</section>